export default "__VITE_ASSET__CVJ_g$Qw__"